<template slot-scope="scope">
  <!-- 补充内容 / 申诉（样式对齐右侧反馈弹框） -->
  <dialogModel
    :title="dialogTitle"
    :visible="dialogContent"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
  >
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item :label="contentLabel" prop="textarea">
          <el-input
            type="textarea"
            :placeholder="contentPlaceholder"
            v-model="ruleForm.textarea"
            maxlength="3000"
            show-word-limit
            resize="none"
            :autosize="true"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <label style="margin-top: 20px; margin-bottom: 10px; display: block"
        >上传资料：</label
      >
      <div class="Upload-box" v-loading="loading">
        <input
          type="file"
          @change="onFileChange"
          id="fileContentFill"
          ref="batchImport"
        />
        <input
          type="button"
          value="点击上传"
          class="btn firm-clickable"
          @click="clickFile"
        />
        <p>请上传zip文件，大小在10MB以内</p>
        <p style="color: #409eff ">{{ fileName }}</p>
      </div>
    </div>
  </dialogModel>
</template>

<script>
import {
  postAddComplaintExtendInfo,
} from "../../../../../../assets/api/index";
export default {
  props: {
    dialogContent: {},
    result: {},
    compId: {},
    type: {},
  },
  data() {
    return {
      loading: false,
      ruleForm: { textarea: "" },
      rules: {
        textarea: [
          {
            required: true,
            min: 15,
            message: "请输入至少15字的内容！",
            trigger: ["blur", "change"],
          },
        ],
      },
      fileName: "",
      TXurlPath: "",
      docId: "",
      docName: "",
    };
  },
  watch: {
    dialogContent: {
      handler(newss) {
        if (newss == false) {
          this.fileName = "";
          this.TXurlPath = "";
          this.docId = "";
          this.docName = "";
          this.ruleForm.textarea = "";
          this.loading = false;
          if (this.$refs.batchImport) {
            this.$refs.batchImport.value = "";
          }
          setTimeout(() => {
            if (this.$refs.ruleForm) {
              this.$refs.ruleForm.clearValidate();
            }
          }, 300);
        }
      },
      immediate: false,
    },
  },
  computed: {
    dialogTitle() {
      return this.result == 6 ? "申诉" : "补充内容";
    },
    contentLabel() {
      return this.result == 6 ? "申诉内容" : "补充内容";
    },
    contentPlaceholder() {
      return this.result == 6
        ? "请输入至少15个字的申诉内容"
        : "请输入至少15个字的补充内容";
    },
  },
  methods: {
    clickFile() {
      if (this.$refs.batchImport) {
        this.$refs.batchImport.click();
      }
    },
    async onFileChange(event, opt, callback) {
      this.loading = true;
      var file = event.target.files[0] || event.dataTransfer.files[0];
      if (!file) {
        this.loading = false;
        return;
      }
      var fileSuffix1 = file.name;
      var fileArr = fileSuffix1.split(".");
      var fileSuffix = fileArr[fileArr.length - 1];
      if (fileSuffix == "zip") {
        this.fileName = file.name;
        var arr = await this.$tool.onFileChangeNew(event, opt, callback);
        if (arr.code == 0) {
          this.loading = false;
          this.TXurlPath = arr.TXurl;
          this.docId = arr.docId;
          this.docName = arr.docName;
        } else {
          this.loading = false;
          this.fileName = "";
        }
        this.$refs.batchImport.value = "";
      } else {
        this.loading = false;
        this.$tool.PromptBox("error", "请上传zip文件");
        this.$refs.batchImport.value = "";
      }
    },
    handleClose() {
      this.$emit("handleClose", this.result);
    },
    handleUnderstand() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          var data = {
            data: {
              compId: this.compId,
              createBy: this.$store.getters.getUser.id,
              type: this.type,
              content: this.ruleForm.textarea,
              attachmentId: this.docId,
              attachmentName: this.docName,
            },
          };
          postAddComplaintExtendInfo(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
            }
            this.$emit("handleUnderstand", this.result);
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-textarea .el-input__count {
  bottom: -30px !important;
}
/deep/.el-form-item {
  margin-bottom: 6px;
}
/deep/.el-form-item__label {
  text-align: left !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
  min-height: 80px !important;
}
/deep/.el-form-item.is-error .el-textarea__inner {
  border-color: #fe574a !important;
}

.Upload-box {
  width: 250px;
  height: 100px;
  border: 1px dashed #409eff ;
  margin-right: 20px;

  #fileContentFill {
    display: none;
  }

  input {
    border: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    width: 100%;
    text-align: center;
    color: #409eff ;
    margin-top: 40px;
  }
  p {
    width: 100%;
    text-align: center;
    font-size: 10px;
  }
}
</style>
